/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StudentProfileDna } from '../../models/student-profile-dna';

export interface GetCurrentStudentDna$Params {
  profileId: string;
}

export function getCurrentStudentDna(http: HttpClient, rootUrl: string, params: GetCurrentStudentDna$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentProfileDna>> {
  const rb = new RequestBuilder(rootUrl, getCurrentStudentDna.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StudentProfileDna>;
    })
  );
}

getCurrentStudentDna.PATH = '/studentprofile/{profileId}/dna/current';
